module.exports = __webpack_public_path__ + "img/egg_squares_happy.6a2ad9d0.svg";